export default __webpack_public_path__ + "static/media/pdf-placeholder.2fddbc18.svg";